import axios from "axios";
import config from "../config.json";
import { getAccessToken, getTransactionToken } from "./config";

const url =
  config.env !== "local"
    ? config.REACT_APP_BASE_URL
    : config.REACT_APP_TEST_URL;

// Create an Axios instance
const api = axios.create({
  baseURL: url,
});

// Utility function to check if the endpoint needs the transaction token
const needsTransactionToken = (url) => {
  return url.includes("/insurance/info/") || url.includes("/Initiate/payment");
};

// Axios interceptor
api.interceptors.request.use(
  async (config) => {
    // Dynamically fetch tokens before each request
    const accessToken = getAccessToken();
    const transactionToken = getTransactionToken();

    //console.log("transactionToken", transactionToken)
    //console.log("accessToken", accessToken)

    if (accessToken) {
      config.headers["Authorization"] = `${accessToken}`;
    }

    // Add TransactionToken only for specific endpoints
    if (needsTransactionToken(config.url) && transactionToken) {
      config.headers["TransactionToken"] = `${transactionToken}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Method to call API endpoints

export default api;
